import type { IntrospectionQuery } from 'graphql'
export default {
    '__schema': {
        'queryType': {
            'name': 'Query',
        },
        'mutationType': {
            'name': 'Mutation',
        },
        'subscriptionType': null,
        'types': [
            {
                'kind': 'UNION',
                'name': 'AddToCartReadyToGoRingExistingCustomerResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'AddToCartReadyToGoRingSuccessExistingCustomer',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'AddToCartReadyToGoRingNewCustomerResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'AddToCartReadyToGoRingSuccessNewCustomer',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'AddToCartReadyToGoRingSuccessExistingCustomer',
                'fields': [
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AddToCartReadyToGoRingSuccessNewCustomer',
                'fields': [
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CustomerRegistrationResponse',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Address',
                'fields': [
                    {
                        'name': 'country',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'phoneNumber',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PhoneNumberType',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AffirmCompleteTransactionResponse',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AffirmFinanceOption',
                'fields': [
                    {
                        'name': 'months',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'perMonth',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AffirmPaymentMethod',
                'fields': [
                    {
                        'name': 'publicKey',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'scriptUrl',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AffirmPaymentResponse',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AffirmTransaction',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'checkoutObject',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'status',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'TransactionStatus',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'TransactionInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'AllocationPaymentMethod',
                'fields': [
                    {
                        'name': 'maxAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AllocationTransaction',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'status',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'TransactionStatus',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'TransactionInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ArticleGridItem',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ArticlePreview',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'subtitle',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Asset',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mimeType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'size',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'MonolithImageSize',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'name',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'sources',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ImageSrc',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Author',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'postAggregation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'PostsAggregation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'posts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Post',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'page',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AuthorsAggregation',
                'fields': [
                    {
                        'name': 'count',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AvatarStackItem',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'AvataxAddressInvalidError',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BankPaymentMethod',
                'fields': [
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BankTransaction',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'status',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'TransactionStatus',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'TransactionInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'Banner1',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'backgroundImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'button',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'ComponentButton',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'preTitle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Banner2',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'button',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'ComponentButton',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'preTitle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Block',
                'fields': [
                    {
                        'name': 'anchor',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'BlockAnchor',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'backgroundOverflow',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'collapsibleTitle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'components',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'Component',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'display',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isCollapsible',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isOpenByDefault',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'verticalSpacing',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BlockAnchor',
                'fields': [
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultation',
                'fields': [
                    {
                        'name': 'canBeCancelled',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'consultant',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Consultant',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'consultationRoom',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'BookingConsultationRoom',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Customer',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isCancelled',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'method',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BookingConsultationMethod',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'note',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Order',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'purpose',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BookingConsultationPurpose',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salesforceId',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'showroom',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Showroom',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'startsAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'state',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationAvailableDate',
                'fields': [
                    {
                        'name': 'consultationAvailableShowrooms',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'BookingConsultationAvailableShowroom',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'date',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationAvailableShowroom',
                'fields': [
                    {
                        'name': 'consultationSlots',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BookingConsultationSlot',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationComplexity',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BookingConsultationComplexityTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationComplexityTranslation',
                'fields': [
                    {
                        'name': 'locale',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationMethod',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isVirtual',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'takesRoom',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationPurpose',
                'fields': [
                    {
                        'name': 'duration',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'methods',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'BookingConsultationMethod',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'requireConsultant',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'requireOrder',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'BookingConsultationPurposeOrder',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'slotLengthInMinutes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'takesRoom',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'type',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BookingConsultationType',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationPurposeOrder',
                'fields': [
                    {
                        'name': 'orders',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'OBJECT',
                                    'name': 'Order',
                                    'ofType': null,
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'statuses',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'OrderStatus',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'BookingConsultationRoom',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'kind',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'BookingInPersonConsultationRoom',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'BookingVirtualConsultationRoom',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationSlot',
                'fields': [
                    {
                        'name': 'showroom',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Showroom',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'startTime',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationSlotsResponse',
                'fields': [
                    {
                        'name': 'slots',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'BookingConsultationSlot',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingConsultationType',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingCreateConsultationErrorNoAvailableConsultants',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'BookingCreateConsultationExistingCustomerResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'BookingCreateConsultationErrorNoAvailableConsultants',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'BookingCreateConsultationSuccessExistingCustomer',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'BookingCreateConsultationNewCustomerResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'BookingCreateConsultationErrorNoAvailableConsultants',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'BookingCreateConsultationSuccessNewCustomer',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingCreateConsultationSuccessExistingCustomer',
                'fields': [
                    {
                        'name': 'consultation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BookingConsultation',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingCreateConsultationSuccessNewCustomer',
                'fields': [
                    {
                        'name': 'consultation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BookingConsultation',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customerRegistrationResponse',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CustomerRegistrationResponse',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingInPersonConsultationRoom',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'kind',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'BookingConsultationRoom',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'BookingVirtualConsultationRoom',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'kind',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'BookingConsultationRoom',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ButtonEventTracking',
                'fields': [
                    {
                        'name': 'action',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'category',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'event',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ButtonIcon',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'position',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ButtonStyle',
                'fields': [
                    {
                        'name': 'bottomSpacing',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'linkSize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'size',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'topSpacing',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'type',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CardCarouselCard',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CarouselCustomProduct',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Link',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueAggregate',
                'fields': [
                    {
                        'name': 'count',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueBandType',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueBandTypeTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueBandTypeTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio',
                'fields': [
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DesignStudioProductEngagementRing',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart',
                'fields': [
                    {
                        'name': 'checkoutProduct',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStudioProduct',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DesignStudioProductEngagementRing',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'CatalogueDesignStudioCheckoutJewelleryExistingCustomerResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'CatalogueDesignStudioCheckoutJewelleryNewCustomerResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer',
                'fields': [
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer',
                'fields': [
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CustomerRegistrationResponse',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'CatalogueDesignStudioCheckoutWeddingRingExistingCustomerResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer',
                'fields': [
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer',
                'fields': [
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CustomerRegistrationResponse',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueEngagementRing',
                'fields': [
                    {
                        'name': 'bandThickness',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'bandWidth',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'centreStoneConstraints',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueEngagementRingCentreStoneConstraints',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customTitleTag',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'EngagementRingDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyle',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingDesignStyleLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images360',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GenericImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAvailableForRingBuilder',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isResizeable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isReturnable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'meleeItems',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueMelee',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueEngagementRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringBuilderProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'RingBuilder',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'ringStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'EngagementRingStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Melee',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueEngagementRingAndSignatureStone',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'sizes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'RingSizeOrRecommendedRingSize',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffix',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffixSlug',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueEngagementRingTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'updatedAt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'variations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueEngagementRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'variationsByCentreStoneShape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueEngagementRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'variationsByPrimaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueEngagementRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'video',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueVideo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueEngagementRingAndSignatureStone',
                'fields': [
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'signatureStone',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueEngagementRingSignatureStone',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueEngagementRingCentreStoneConstraints',
                'fields': [
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'weight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueEngagementRingCentreStoneWeightConstraint',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueEngagementRingCentreStoneWeightConstraint',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueEngagementRingFilters',
                'fields': [
                    {
                        'name': 'centreStoneShapes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterShapeItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterEngagementRingDesignFeatureItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterEngagementRingDesingStyleItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRangeFilter',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'primaryMetals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterMetalItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterEngagementRingStylesItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueEngagementRingFiltersVariation',
                'fields': [
                    {
                        'name': 'centreStoneShape',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'designFeature',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueEngagementRingSignatureStone',
                'fields': [
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isDefault',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueEngagementRingTranslation',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'locale',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'seoText',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterEngagementRingDesignFeatureItem',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingDesignFeatureLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterEngagementRingDesingStyleItem',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingDesignStyleLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterEngagementRingStylesItem',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStyleLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterJewelleryBraceletProductStyleLabel',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'JewelleryBraceletProductStyleLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterJewelleryDesignFeatureLabel',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'JewelleryDesignFeatureLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterJewelleryDesignStyleLabel',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'JewelleryDesignStyleLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterJewelleryEarringsProductStyleLabel',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'JewelleryEarringsProductStyleLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterJewelleryGemstoneLabel',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'JewelleryGemstoneLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterJewelleryNecklaceProductStyleLabel',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'JewelleryNecklaceProductStyleLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterJewelleryRingProductStyleLabel',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'JewelleryRingProductStyleLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterMetalItem',
                'fields': [
                    {
                        'name': 'metal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterShapeItem',
                'fields': [
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterWeddingRingCategoriesItem',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'WeddingRingCategoryLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueFilterWeddingRingStylesItem',
                'fields': [
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'WeddingRingStyleLabel',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueImage',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mimeType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'size',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'MonolithImageSize',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'name',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'sources',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ImageSrc',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleriesBraceletsFiltersVariation',
                'fields': [
                    {
                        'name': 'designFeature',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstone',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleriesEarringsFiltersVariation',
                'fields': [
                    {
                        'name': 'designFeature',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstone',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleriesFilters',
                'fields': [
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRangeFilter',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'primaryMetals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterMetalItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleriesFiltersVariation',
                'fields': [
                    {
                        'name': 'designFeature',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstone',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleriesNecklacesFiltersVariation',
                'fields': [
                    {
                        'name': 'designFeature',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstone',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleriesRingsFiltersVariation',
                'fields': [
                    {
                        'name': 'designFeature',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstone',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'CatalogueJewellery',
                'fields': [
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customTitleTag',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'engravingDisabled',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images360',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GenericImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isReturnable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'CatalogueProduct',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'sku',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffix',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffixSlug',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'updatedAt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'video',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueVideo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueProduct',
                    },
                ],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueJewelleryBracelet',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueJewelleryEarrings',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueJewelleryNecklace',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueJewelleryRing',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryBracelet',
                'fields': [
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customTitleTag',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'engravingDisabled',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images360',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GenericImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isReturnable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryBraceletProductStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryBracelet',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Melee',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'sku',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffix',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffixSlug',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueJewelleryBraceletTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'updatedAt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'variations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryBracelet',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'video',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueVideo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueJewellery',
                    },
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryBraceletTranslation',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'seoText',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryBraceletsFilters',
                'fields': [
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRangeFilter',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'primaryMetals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterMetalItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryBraceletProductStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryEarrings',
                'fields': [
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customTitleTag',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'engravingDisabled',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images360',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GenericImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isReturnable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryEarringsProductStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryEarrings',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Melee',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'sku',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffix',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffixSlug',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueJewelleryEarringsTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'updatedAt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'variations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryEarrings',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'video',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueVideo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueJewellery',
                    },
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryEarringsFilters',
                'fields': [
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRangeFilter',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'primaryMetals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterMetalItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryEarringsProductStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryEarringsTranslation',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'seoText',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryNecklace',
                'fields': [
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customTitleTag',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'engravingDisabled',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images360',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GenericImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isReturnable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryNecklaceProductStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryNecklace',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Melee',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'sku',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffix',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffixSlug',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueJewelleryNecklaceTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'updatedAt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'variations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryNecklace',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'video',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueVideo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueJewellery',
                    },
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryNecklaceTranslation',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'seoText',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryNecklacesFilters',
                'fields': [
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRangeFilter',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'primaryMetals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterMetalItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryNecklaceProductStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryRing',
                'fields': [
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customTitleTag',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'engravingDisabled',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images360',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GenericImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isResizeable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isReturnable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'JewelleryRingProductStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Melee',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'sizes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'RingSizeOrRecommendedRingSize',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'sku',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffix',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffixSlug',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueJewelleryRingTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'updatedAt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'variations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'video',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueVideo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueJewellery',
                    },
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryRingTranslation',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'seoText',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueJewelleryRingsFilters',
                'fields': [
                    {
                        'name': 'designFeatures',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignFeatureLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryDesignStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'gemstones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryGemstoneLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRangeFilter',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'primaryMetals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterMetalItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterJewelleryRingProductStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueMelee',
                'fields': [
                    {
                        'name': 'melee',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Melee',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quantity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CataloguePriceRange',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CataloguePriceRangeBar',
                'fields': [
                    {
                        'name': 'range',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalResults',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CataloguePriceRangeFilter',
                'fields': [
                    {
                        'name': 'absoluteRange',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'bars',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CataloguePriceRangeBar',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'currentRange',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'CatalogueProduct',
                'fields': [
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customTitleTag',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'isReturnable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'CatalogueProduct',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffix',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffixSlug',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'updatedAt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueEngagementRing',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueJewelleryBracelet',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueJewelleryEarrings',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueJewelleryNecklace',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueJewelleryRing',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueReadyToGoRing',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueWeddingRing',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueReadyToGoRing',
                'fields': [
                    {
                        'name': 'carat',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customTitleTag',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'gemType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'isReadyToShip',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isReturnable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueReadyToGoRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shortDescription',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'shortName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Melee',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'sizes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'RecommendedRingSize',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'sku',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffix',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffixSlug',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueReadyToGoRingTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'updatedAt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'variations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueReadyToGoRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueReadyToGoRingFilters',
                'fields': [
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRangeFilter',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'primaryMetals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterMetalItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueReadyToGoRingTranslation',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'seoText',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueVideo',
                'fields': [
                    {
                        'name': 'type',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'uri',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueWeddingRing',
                'fields': [
                    {
                        'name': 'bandThickness',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'bandType',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueBandType',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'bandWidth',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'categories',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'WeddingRingCategoryLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customTitleTag',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'hasEngraving',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'images360',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GenericImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isResizeable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isReturnable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'meleeItems',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueMelee',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Metal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueWeddingRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'WeddingRingStyleLabel',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Melee',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'sizes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'RingSizeOrRecommendedRingSize',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffix',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'suffixSlug',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueWeddingRingTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'updatedAt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'variations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueWeddingRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'video',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueVideo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'CatalogueProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueWeddingRingFilters',
                'fields': [
                    {
                        'name': 'categories',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterWeddingRingCategoriesItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CataloguePriceRangeFilter',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'primaryMetals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterMetalItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringStyles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueFilterWeddingRingStylesItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueWeddingRingFiltersVariation',
                'fields': [
                    {
                        'name': 'category',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'primaryMetal',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CatalogueWeddingRingTranslation',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'locale',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'seoText',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CheckoutcomOperationDeclinedError',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CheckoutcomPaymentMethod',
                'fields': [
                    {
                        'name': 'debugMode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'publicKey',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CheckoutcomTransaction',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'status',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'TransactionStatus',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'TransactionInterface',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'CompleteCheckoutcomTransactionPost3dsError',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CheckoutcomOperationDeclinedError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesiredDeliveryDateInvalidError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'OrderAlreadyCompletedError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'PaymentAmountInvalidError',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CompleteCheckoutcomTransactionPost3dsFailureResponse',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'CompleteCheckoutcomTransactionPost3dsError',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'CompleteCheckoutcomTransactionPost3dsResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CompleteCheckoutcomTransactionPost3dsFailureResponse',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CompleteCheckoutcomTransactionPost3dsSuccessResponse',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CompleteCheckoutcomTransactionPost3dsSuccessResponse',
                'fields': [
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'Component',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentArticleGrid',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentArticlePreviews',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentBannerSkinny',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentBannerTitle',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentCard',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentCardCarousel',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentCatalogueProductCarousel',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentContent',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentContentTwoColumns',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentContentWithGallery',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentCustomProductCarousel',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentFaq',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentFullWidthImage',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentGalleryCarousel',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentGalleryWithEnquiry',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentGlobalComponent',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentGlobalSpacer',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentIconCarousel',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentInstagramPosts',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentInstagramWithContent',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentLogos',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentLogosCarousel',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentMainCover',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentOnThisPage',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentQuote',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentRelatedProducts',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentReviewCarousel',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentRoundedImage',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentRoundedImageContent',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentShopWithConfidence',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentSideBySideImages',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentSquareBoxes',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentTable',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentTextCarousel',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentTextOverImage',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentTextWithImage',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentTextWithImageCarousel',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentVideo',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentVideoWithContent',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentArticleGrid',
                'fields': [
                    {
                        'name': 'articles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ArticleGridItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentArticlePreviews',
                'fields': [
                    {
                        'name': 'articles',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ArticlePreview',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentBannerSkinny',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'backgroundGraphic',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'backgroundImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ComponentTitle',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'useBackgroundImage',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentBannerTitle',
                'fields': [
                    {
                        'name': 'date',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'tag',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentButton',
                'fields': [
                    {
                        'name': 'alignment',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'eventTracking',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'ButtonEventTracking',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'ButtonIcon',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'style',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ButtonStyle',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentCard',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentCardCarousel',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CardCarouselCard',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentCatalogueProductCarousel',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ComponentCatalogueProductCarouselItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentCatalogueProductCarouselItem',
                'fields': [
                    {
                        'name': 'catalogueCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'CatalogueProduct',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentContent',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentContentTwoColumns',
                'fields': [
                    {
                        'name': 'leftColumnBackgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'leftColumnContent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'rightColumnBackgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'rightColumnContent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentContentWithGallery',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'gallery',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GalleryItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentCustomProductCarousel',
                'fields': [
                    {
                        'name': 'products',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CarouselCustomProduct',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentFaq',
                'fields': [
                    {
                        'name': 'sections',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'FaqSection',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'showNavigation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentFullWidthImage',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Link',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentGalleryCarousel',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GalleryCarouselCard',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentGalleryWithEnquiry',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GalleryWithEnquiryCard',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'type',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentGlobalComponent',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'components',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'Component',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentGlobalSpacer',
                'fields': [
                    {
                        'name': 'spacing',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentIconCarousel',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'IconCarouselItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentImage',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentInstagramPosts',
                'fields': [
                    {
                        'name': 'instagramUser',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'instagramUserLink',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'posts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'InstagramPost',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'preTitle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ComponentTitle',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentInstagramWithContent',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'UNION',
                                    'name': 'ContentComponentItem',
                                    'ofType': null,
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'instagramEmbedCode',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'instagramImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'instagramLink',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'instagramPosition',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'instagramUsername',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'useImage',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentLogos',
                'fields': [
                    {
                        'name': 'logos',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Logo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentLogosCarousel',
                'fields': [
                    {
                        'name': 'logos',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Logo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentMainCover',
                'fields': [
                    {
                        'name': 'backgroundImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mobileBackgroundImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentOnThisPage',
                'fields': [
                    {
                        'name': 'null',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentOrderedList',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'OrderedListItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentQuote',
                'fields': [
                    {
                        'name': 'author',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'hasBackgroundImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'quote',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'showQuotationMarks',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'size',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentRelatedProducts',
                'fields': [
                    {
                        'name': 'null',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentReviewCarousel',
                'fields': [
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ReviewCarouselCard',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentRoundedImage',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'backgroundImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'backgroundImageColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'roundedImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentRoundedImageContent',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'roundedImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ComponentRoundedImage',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentShopWithConfidence',
                'fields': [
                    {
                        'name': 'components',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'ShopWithConfidenceComponent',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ethnicallySourcedDiamonds',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'financingOptions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'greenlandRuby',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'handFinished',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'resize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'returnPolicy',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shipping',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'ComponentTitle',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentSideBySideImage',
                'fields': [
                    {
                        'name': 'caption',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Link',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentSideBySideImages',
                'fields': [
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ComponentSideBySideImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentSpacer',
                'fields': [
                    {
                        'name': 'spacing',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentSquareBoxes',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'SquareBoxes',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentTable',
                'fields': [
                    {
                        'name': 'table',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Table',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentText',
                'fields': [
                    {
                        'name': 'alignment',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'textSize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentTextCarousel',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'TextCarouselItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentTextOverImage',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentTextWithImage',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'imageFormat',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'imagePosition',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'padding',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentTextWithImageCarousel',
                'fields': [
                    {
                        'name': 'slidePadding',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'slides',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ComponentTextWithImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentTitle',
                'fields': [
                    {
                        'name': 'alignment',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'tag',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'texts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ComponentTitleComponent',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'titleSize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'titleStyle',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'titleWidth',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentTitleAmpersand',
                'fields': [
                    {
                        'name': 'null',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'ComponentTitleComponent',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentTitleAmpersand',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentTitleText',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentTitleText',
                'fields': [
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentVideo',
                'fields': [
                    {
                        'name': 'video',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Video',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ComponentVideoWithContent',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'coverImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'video',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Video',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'videoPosition',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Consultant',
                'fields': [
                    {
                        'name': 'avatar',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'avatarImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GenericImage',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'canTakeConsultations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'firstName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'showroom',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Showroom',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'user',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'User',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'ContentComponentItem',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentButton',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentImage',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentOrderedList',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentSpacer',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentText',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ComponentTitle',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'CreateCheckoutcomTransactionError',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'AvataxAddressInvalidError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesiredDeliveryDateInvalidError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'OrderAddressNotConfirmedError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'OrderAlreadyCompletedError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'OrderEmptyError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'PaymentAmountInvalidError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'PaymentMethodNotAllowedError',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CreateCheckoutcomTransactionFailureResponse',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'CreateCheckoutcomTransactionError',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'CreateCheckoutcomTransactionResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CreateCheckoutcomTransactionFailureResponse',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CreateCheckoutcomTransactionSuccessResponse',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'CreateCheckoutcomTransactionSuccessResponse',
                'fields': [
                    {
                        'name': 'transaction',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CheckoutcomTransaction',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Customer',
                'fields': [
                    {
                        'name': 'adminProfileUrl',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'billingAddress',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Address',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'cart',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'consultant',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Consultant',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'designInspiration',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'DesignInspiration',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStudioProduct',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'DesignStudioProduct',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'designStudioProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'DesignStudioProduct',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'disabledThirdPartyCookies',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'engagementRingRecommendations',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'UserCustomerEngagementRingRecommendations',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'enquiries',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'Enquiry',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Order',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'orders',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Order',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ordersByConsultationPurpose',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Order',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'purpose',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'questionnaireByType',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'QuestionnaireCompletedQuestionnaire',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'type',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'salesforceProfileUrl',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'shippingAddress',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Address',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'user',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'User',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'CustomerRegistrationResponse',
                'fields': [
                    {
                        'name': 'login',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'LoginResponseSuccess',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DeliveryDate',
                'fields': [
                    {
                        'name': 'date',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'validUntil',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignInspiration',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'DesignStudioCentreStone',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioExternalCentreStone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioInternalCentreStone',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioEngagementRingCentreStone',
                'fields': [
                    {
                        'name': 'approved',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'comment',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'manualSurcharges',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuotationManualSurcharge',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'percentageSurcharge',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'QuotationPercentageSurcharge',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'stone',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'DesignStudioCentreStone',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'DesignStudioEngagementRingError',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioEngagementRingErrorGeneric',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioEngagementRingErrorMaxCaratWeight',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioEngagementRingErrorMinCaratWeight',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioEngagementRingErrorShapeMismatch',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioEngagementRingErrorGeneric',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioEngagementRingErrorMaxCaratWeight',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioEngagementRingErrorMinCaratWeight',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioEngagementRingErrorShapeMismatch',
                'fields': [
                    {
                        'name': 'matchingVariation',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueEngagementRing',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioEngagementRingFailure',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'DesignStudioEngagementRingError',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioEngagementRingMount',
                'fields': [
                    {
                        'name': 'approved',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'comment',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'manualSurcharges',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuotationManualSurcharge',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'melees',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'DesignStudioMeleeItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'metals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Metal',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'percentageSurcharge',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'QuotationPercentageSurcharge',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'sideStones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'DesignStudioSideStone',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'DesignStudioSignatureStone',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioExternalCentreStone',
                'fields': [
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneCrystal',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'weight',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioExternalSideStone',
                'fields': [
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneCrystal',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'weight',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioInternalCentreStone',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSku',
                        'type': {
                            'kind': 'UNION',
                            'name': 'HistoricalNonSku',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'sku',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Stone',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioInternalSideStone',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'item',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'DesignStudioSideStoneItem',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quantity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioMeleeItem',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'melee',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Melee',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quantity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'DesignStudioProduct',
                'fields': [
                    {
                        'name': 'cantBeResized',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cantBeReturned',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalQuotation',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'Quotation',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAutofinalizable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'orderProduct',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quotations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'Quotation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioProductAdditionalResize',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioProductCustom',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioProductEngagementRing',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioProductGeneric',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioProductLooseStone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioProductWeddingRing',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioProductAdditionalResize',
                'fields': [
                    {
                        'name': 'cantBeResized',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cantBeReturned',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalQuotation',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'Quotation',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAutofinalizable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'orderProduct',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quotations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'Quotation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'DesignStudioProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioProductCustom',
                'fields': [
                    {
                        'name': 'cantBeResized',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cantBeReturned',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalQuotation',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'Quotation',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAutofinalizable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'orderProduct',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quotations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'Quotation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'DesignStudioProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioProductEngagementRing',
                'fields': [
                    {
                        'name': 'availableSizes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'RingSizeOrRecommendedRingSize',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cantBeResized',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cantBeReturned',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'engraving',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalQuotation',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'Quotation',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAutofinalizable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'orderProduct',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quotations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuotationEngagementRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'size',
                        'type': {
                            'kind': 'UNION',
                            'name': 'RingSizeOrRecommendedRingSize',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'DesignStudioProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioProductGeneric',
                'fields': [
                    {
                        'name': 'cantBeResized',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cantBeReturned',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Customer',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalQuotation',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'Quotation',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAutofinalizable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'orderProduct',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quotations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'Quotation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'DesignStudioProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioProductLooseStone',
                'fields': [
                    {
                        'name': 'cantBeResized',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cantBeReturned',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalQuotation',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'Quotation',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAutofinalizable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'orderProduct',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quotations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'Quotation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'DesignStudioProduct',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioProductWeddingRing',
                'fields': [
                    {
                        'name': 'availableSizes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'RingSizeOrRecommendedRingSize',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cantBeResized',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cantBeReturned',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'engraving',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalQuotation',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'Quotation',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAutofinalizable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'orderProduct',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderProduct',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'quotations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuotationWeddingRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'size',
                        'type': {
                            'kind': 'UNION',
                            'name': 'RingSizeOrRecommendedRingSize',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'DesignStudioProduct',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'DesignStudioSideStone',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioExternalSideStone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioInternalSideStone',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'DesignStudioSideStoneItem',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'Melee',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'Stone',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesignStudioSignatureStone',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'melee',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Melee',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'DesiredDeliveryDateInvalidError',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EngagementRingDesignFeatureLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EngagementRingDesignStyleLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EngagementRingStoneRecommendationCard',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'notFoundContent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'notSupportedContent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EngagementRingStoneRecommendationNaturalDiamonds',
                'fields': [
                    {
                        'name': 'forBalanceCard',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStoneRecommendationCard',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'forSizeCard',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStoneRecommendationCard',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'labGrownAlternative',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStoneRecommendationCard',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EngagementRingStoneRecommendationNonSkuGemStoneCard',
                'fields': [
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStoneRecommendationCard',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EngagementRingStoneRecommendationNonSkuLabGrown',
                'fields': [
                    {
                        'name': 'forPriceCard',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStoneRecommendationCard',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'forSizeCard',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStoneRecommendationCard',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'naturalDiamondAlternative',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStoneRecommendationCard',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EngagementRingStoneRecommendations',
                'fields': [
                    {
                        'name': 'blocks',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Block',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'fullSearchButtonText',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'introductionText',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'naturalDiamonds',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStoneRecommendationNaturalDiamonds',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuGemStones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'EngagementRingStoneRecommendationNonSkuGemStoneCard',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'colorCodes',
                                'type': {
                                    'kind': 'LIST',
                                    'ofType': {
                                        'kind': 'NON_NULL',
                                        'ofType': {
                                            'kind': 'SCALAR',
                                            'name': 'Any',
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrown',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EngagementRingStoneRecommendationNonSkuLabGrown',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EngagementRingStyleLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'Enquiry',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'EnquiryConsultation',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'EnquiryEngagementRingAddToCart',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'EnquiryWeddingRingAddToCart',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'EnquiryConsultation',
                'fields': [
                    {
                        'name': 'consultation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BookingConsultation',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EnquiryEngagementRingAddToCart',
                'fields': [
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DesignStudioProductEngagementRing',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EnquiryResponseExistingCustomer',
                'fields': [
                    {
                        'name': 'marketingCloudForm',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EnquiryResponseNewCustomer',
                'fields': [
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CustomerRegistrationResponse',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'marketingCloudForm',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'EnquiryWeddingRingAddToCart',
                'fields': [
                    {
                        'name': 'product',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DesignStudioProductWeddingRing',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'FaqQuestion',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'expandedByDefault',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'FaqSection',
                'fields': [
                    {
                        'name': 'questions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'FaqQuestion',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Footer',
                'fields': [
                    {
                        'name': 'columns',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'FooterColumn',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'copyright',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'logos',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'FooterLogo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'FooterColumn',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'FooterColumnItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'FooterColumnItem',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'FooterColumnItemLinkList',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'FooterColumnItemSeparator',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'FooterColumnItemText',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'FooterColumnItemTitle',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'FooterColumnItemWorkingHours',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'FooterColumnItemLink',
                'fields': [
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'FooterColumnItemLinkList',
                'fields': [
                    {
                        'name': 'links',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'FooterColumnItemLink',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'FooterColumnItemSeparator',
                'fields': [
                    {
                        'name': 'line',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'FooterColumnItemText',
                'fields': [
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'FooterColumnItemTitle',
                'fields': [
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'FooterColumnItemWorkingHours',
                'fields': [
                    {
                        'name': 'workingHours',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'WorkingHours',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'FooterLogo',
                'fields': [
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'logo',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GalleryCarouselCard',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Link',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GalleryItem',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GalleryWithEnquiryCard',
                'fields': [
                    {
                        'name': 'caption',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApiPriceBounds',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApiStone',
                'fields': [
                    {
                        'name': 'identifier',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'stone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_Stone',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_Bounds',
                'fields': [
                    {
                        'name': 'categories',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneCategoryInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'category',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarities',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneClarityInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneColorInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colour',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneCrystalInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cuts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneCutInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_IntRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'depth',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_Range',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'depthPercent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_Range',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'fluorescence',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'fluorescences',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneFluorescenceInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'grade',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'grades',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneGradeInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'length',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_Range',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'originCountry',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'polish',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'polishes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StonePolishInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_PriceRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'priceByShape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_PriceRangeByShape',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ratio',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_Range',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shapes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneShapeInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shippingFromCountry',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'symmetries',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneSymmetryInfo',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'symmetry',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'tablePercent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_Range',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'weight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_Range',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_Range',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_IntRange',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_Pagination',
                'fields': [
                    {
                        'name': 'limit',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'page',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'pages',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'total',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_PricePoint',
                'fields': [
                    {
                        'name': 'market',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_PriceRange',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'maxInCurrency',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Money',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'minInCurrency',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Money',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_PriceRangeByShape',
                'fields': [
                    {
                        'name': 'range',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_PriceRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_Range',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_SelectedRange',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_SelectedSorting',
                'fields': [
                    {
                        'name': 'direction',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'field',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_SelectedStoneFilters',
                'fields': [
                    {
                        'name': 'category',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'collection',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colour',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'costPrice',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'depth',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'depthPercent',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'fluorescence',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'grade',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'hasPhoto',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'isCanadaMark',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'isDtlReport',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'isRtg',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'isScsReport',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'isStock',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'lab',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'length',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'notClarity',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'notColour',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'notSymmetry',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'originCountry',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'polish',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'priceIndex',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'ratio',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shippingFrom',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'sorting',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedSorting',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'symmetry',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'tablePercent',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'weight',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_SelectedRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'withOriginCountry',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'withVideo',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_Stone',
                'fields': [
                    {
                        'name': 'blackInclusion',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'category',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'categoryWithInfo',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_StoneCategoryInfo',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'certificates',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_StoneCertificates',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarityWithInfo',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_StoneClarityInfo',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colorWithInfo',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_StoneColorInfo',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colour',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colourShade',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'containsEngagementRings',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'crownAngle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'crownHeight',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystalWithInfo',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_StoneCrystalInfo',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'culet',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'cutWithInfo',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_StoneCutInfo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDays',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'depth',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'depthPercent',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'dtlReport',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_dtlReport',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'externalId',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'eyeClean',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'feedIdentifier',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'fluorescence',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'fluorescenceColour',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'fluorescenceWithInfo',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_StoneFluorescenceInfo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'girdleMax',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'girdleMin',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'grade',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'gradeWithInfo',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_StoneGradeInfo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'growthMethod',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'hasPublicImages',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'identifier',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_StoneImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_StoneImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isB2B',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isCanadaMark',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isCertificateVerified',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isHideCertificateNumber',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isHideMeasurements',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isMilky',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'isTreated',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'isValidB2C',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'length',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'originCountry',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'pavilionAngle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'pavilionDepth',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'polish',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'polishWithInfo',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_StonePolishInfo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'pricingNoVat',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_PricePoint',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ratio',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Money',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'scsReport',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shapeWithInfo',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_StoneShapeInfo',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shippingFromCountry',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'symmetry',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'symmetryWithInfo',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_StoneSymmetryInfo',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'tablePercent',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'v360Url',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'weight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneCategoryInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneCategory',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneCertificates',
                'fields': [
                    {
                        'name': 'gcal',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'gia',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'igi',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneClarityInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneClarity',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneCollection',
                'fields': [
                    {
                        'name': 'collection',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApi_Stone',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'filters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_SelectedStoneFilters',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'pagination',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApi_Pagination',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneColorInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneColor',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneCrystalInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneCrystal',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneCutInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneCut',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneFluorescenceInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneFluorescence',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneGradeInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneGrade',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneImage',
                'fields': [
                    {
                        'name': 'isB2B',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StonePolishInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StonePolish',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneShapeInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneShape',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_StoneSymmetryInfo',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'info',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneSymmetry',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GemsApi_dtlReport',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GenericImage',
                'fields': [
                    {
                        'name': 'mimeType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'size',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'MonolithImageSize',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'name',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'sources',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ImageSrc',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'GeoPoint',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'latitude',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'longitude',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'HistoricalNonSku',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'HistoricalNonSkuGemstone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'HistoricalNonSkuLabGrown',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'HistoricalNonSkuGemstone',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarity',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colorGrade',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneGrade',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCut',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'NonSkuGemStoneInterface',
                    },
                    {
                        'kind': 'INTERFACE',
                        'name': 'NonSkuInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'HistoricalNonSkuLabGrown',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarity',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCut',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'NonSkuInterface',
                    },
                    {
                        'kind': 'INTERFACE',
                        'name': 'NonSkuLabGrownInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'IconCarouselItem',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Image',
                'fields': [
                    {
                        'name': 'alt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'caption',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'filename',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'filesize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'height',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mimeType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'size',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ImageSize',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'name',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'sizes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ImageSize',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'sources',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ImageSrc',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'Media',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ImageSize',
                'fields': [
                    {
                        'name': 'mimeType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'sources',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ImageSrc',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ImageSrc',
                'fields': [
                    {
                        'name': 'mimeType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'InstagramPost',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'InvalidateCacheResult',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'InvalidateCacheResultError',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'success',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'InvalidateCacheResultSuccess',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'InvalidateCacheResultError',
                'fields': [
                    {
                        'name': 'error',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'key',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'InvalidateCacheResultSuccess',
                'fields': [
                    {
                        'name': 'key',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'JewelleryBraceletProductStyleLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'JewelleryDesignFeatureLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'JewelleryDesignStyleLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'JewelleryEarringsProductStyleLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'JewelleryGemstoneLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'JewelleryNecklaceProductStyleLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'JewelleryRingProductStyleLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'KlarnaFinanceOption',
                'fields': [
                    {
                        'name': 'months',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'perMonth',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'KlarnaPaymentMethod',
                'fields': [
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'KlarnaPaymentResponse',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'KlarnaTransaction',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'sessionData',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'status',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'TransactionStatus',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'TransactionInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'Language',
                'fields': [
                    {
                        'name': 'locale',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Translation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'LegacyTransaction',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'paymentMethodName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'status',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'TransactionStatus',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'TransactionInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'Link',
                'fields': [
                    {
                        'name': 'item',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'LinkItem',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'target',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'LinkItem',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'LinkItemAffirm',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'LinkItemBookingForm',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'LinkItemCustom',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'LinkItemOpenContactForm',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'LinkItemOpenEnquiryForm',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'LinkItemOpenSpeakToExpertModal',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'Page',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'Post',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'Questionnaire',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'LinkItemAffirm',
                'fields': [
                    {
                        'name': 'emptyField',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'LinkItemBookingForm',
                'fields': [
                    {
                        'name': 'emptyField',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'LinkItemCustom',
                'fields': [
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'LinkItemOpenContactForm',
                'fields': [
                    {
                        'name': 'emptyField',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'LinkItemOpenEnquiryForm',
                'fields': [
                    {
                        'name': 'cmsEnquiryFormType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'enquiryType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'LinkItemOpenSpeakToExpertModal',
                'fields': [
                    {
                        'name': 'emptyField',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'LoginResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'LoginResponseFailure',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'LoginResponseSuccess',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'LoginResponseFailure',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'LoginResponseSuccess',
                'fields': [
                    {
                        'name': 'jwt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'refreshToken',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'user',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'User',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Logo',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'MagicLinkConsumeError',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'MagicLinkConsumeResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'MagicLinkConsumeError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'MagicLinkConsumeSuccess',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'MagicLinkConsumeSuccess',
                'fields': [
                    {
                        'name': 'login',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'LoginResponseSuccess',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'MarketingDataResponse',
                'fields': [
                    {
                        'name': 'success',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'Media',
                'fields': [
                    {
                        'name': 'alt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'caption',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'filename',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'filesize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mimeType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'Image',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'Video',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'Melee',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarities',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneClarity',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneColor',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'grade',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneGrade',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'MenuItem',
                'fields': [
                    {
                        'name': 'hideOnDesktop',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'hideOnMobile',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'subMenu',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'SubMenu',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Meta',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'robots',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Metal',
                'fields': [
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'MetalColor',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'element',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'MetalElement',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'karat',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'millesimalFineness',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'orderIndex',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'segmentName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'MetalTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'MetalColor',
                'fields': [
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'MetalColorTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'MetalColorTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'MetalElement',
                'fields': [
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'MetalElementTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'MetalElementTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'MetalTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Money',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'currency',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'MonolithImageSize',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'sources',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ImageSrc',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Mutation',
                'fields': [
                    {
                        'name': 'addDesignStudioProductToMyCart',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'productId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'addToCartReadyToGoRingExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'AddToCartReadyToGoRingExistingCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'addToCartReadyToGoRingNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'AddToCartReadyToGoRingNewCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'applyPromoCode',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PromoCodeApplicationResult',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'promoCode',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'applyTransitionToConsultationByConsultant',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'BookingConsultation',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'transition',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'autologin',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'LoginResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'authToken',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'cancelConsultation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'completeAffirmTransactionPostIframe',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'AffirmCompleteTransactionResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'completeCheckoutcomTransactionPost3ds',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'CompleteCheckoutcomTransactionPost3dsResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createAffirmTransaction',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'AffirmTransaction',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createAllocationTransaction',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'AllocationTransaction',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createBankTransaction',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BankTransaction',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'orderId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createCheckoutcomTransaction',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'CreateCheckoutcomTransactionResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createConsultationByConsultant',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'BookingConsultation',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'autoAssignConsultant',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'consultationMethod',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'consultationPurpose',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'opportunity',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'order',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'reassignOpportunity',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createConsultationExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'BookingCreateConsultationExistingCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createConsultationNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'BookingCreateConsultationNewCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createDesignInspiration',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DesignInspiration',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'file',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createDesignStudioProductAndAddToCartJewelleryExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'CatalogueDesignStudioCheckoutJewelleryExistingCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createDesignStudioProductAndAddToCartJewelleryNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'CatalogueDesignStudioCheckoutJewelleryNewCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createDesignStudioProductAndAddToCartWeddingRingExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'CatalogueDesignStudioCheckoutWeddingRingExistingCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createDesignStudioProductAndAddToCartWeddingRingNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryContactUsExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseExistingCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryContactUsNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseNewCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryCustomEngagementRingExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseExistingCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryCustomEngagementRingNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseNewCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryDiamondSearchProductExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseExistingCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryDiamondSearchProductNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseNewCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryEngagementRingPreferAnotherShapeExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseExistingCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryEngagementRingPreferAnotherShapeNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseNewCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseExistingCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createEnquiryNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'EnquiryResponseNewCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createKlarnaTransaction',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'KlarnaTransaction',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'designStudioProductEngagementRingUpdate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DesignStudioProductEngagementRing',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'designStudioProductWeddingRingUpdate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DesignStudioProductWeddingRing',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'designStudioQuotationEngagementRingUpdate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuotationEngagementRing',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'impersonate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'LoginResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'identifier',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'invalidateCache',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'InvalidateCacheResult',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'tags',
                                'type': {
                                    'kind': 'LIST',
                                    'ofType': {
                                        'kind': 'NON_NULL',
                                        'ofType': {
                                            'kind': 'SCALAR',
                                            'name': 'Any',
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'login',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'LoginResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'credentials',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'loginWithGoogle',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'LoginResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'credentials',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'logout',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'magicLinkConsume',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'MagicLinkConsumeResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'magicLinkRequest',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'marketingData',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'MarketingDataResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemStoneChangeImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstone',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'image',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemStoneCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstone',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemStoneDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstone',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemStoneDeleteImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstone',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneCaratDimensionCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneCaratDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneCaratDimensionDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneCaratDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneColorCrystalDimensionCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneType',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneColorCrystalDimensionDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneType',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneGradeClarityDimensionCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneGradeClarityDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneGradeClarityDimensionDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneGradeClarityDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneImageCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneImage',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneImageDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneImage',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneImageUpdate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneImage',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneShapeDimensionCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneShapeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneShapeDimensionDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneShapeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownCaratDimensionCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownCaratDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownCaratDimensionDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownCaratDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownDiamondChangeImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrown',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'image',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownDiamondCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrown',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownDiamondDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrown',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownDiamondDeleteImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrown',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownGradeDimensionCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownGradeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownGradeDimensionDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownGradeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownShapeDimensionCreate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownShapeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownShapeDimensionDelete',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownShapeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownShapeDimensionUpdate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownShapeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'payViaAffirm',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'AffirmPaymentResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'payViaAllocation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'allocationTransactionId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'payViaBank',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'bankTransactionId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'payViaCheckoutcom',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'PayViaCheckoutcomResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'payViaKlarna',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'KlarnaPaymentResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'payViaNoPayment',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'orderId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'ping',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'questionnaireCompleteExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireCompletedExistingCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'questionnaireCompleteNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireCompletedNewCustomerResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'refreshToken',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'LoginResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'token',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'removeFromMyCart',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'productId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'ringBuilder',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'RingBuilder',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'ringBuilderResolveExistingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'RingBuilderResolvedExistingCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'ringBuilderResolveNewCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'RingBuilderResolvedNewCustomer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'customer',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'ringBuilderSet',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'RingBuilderSetResult',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'setOrderCollectFromShowroomInformation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'SetDeliveryInformationResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'setOrderDeliverToAddressInformation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'SetDeliveryInformationResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'updateConsultationByConsultant',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'BookingConsultation',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'consultationRoom',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'reassignOpportunity',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NoPaymentMethod',
                'fields': [
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuCaratWeightRange',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'NonSkuGemStoneInterface',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarity',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colorGrade',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneGrade',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCut',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'HistoricalNonSkuGemstone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'NonSkuGemstone',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuGemstone',
                'fields': [
                    {
                        'name': 'caratDimension',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneCaratDimension',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarity',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colorCrystalDimension',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneType',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colorGrade',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneGrade',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCut',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'gradeClarityDimension',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneGradeClarityDimension',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Money',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'sampleImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shapeDimension',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstoneShapeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'uniqueImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'NonSkuGemStoneInterface',
                    },
                    {
                        'kind': 'INTERFACE',
                        'name': 'NonSkuInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuGemstoneCaratDimension',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuGemstoneGradeClarityDimension',
                'fields': [
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarity',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'grade',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneGrade',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuGemstoneImage',
                'fields': [
                    {
                        'name': 'colorCrystalDimension',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuGemstoneType',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'shapeDimension',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuGemstoneShapeDimension',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuGemstoneShapeDimension',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuGemstoneType',
                'fields': [
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuGemstonesBounds',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuCaratWeightRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuPriceRange',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'shapes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneShape',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'types',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuGemstoneType',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuImage',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mimeType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'size',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'MonolithImageSize',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'name',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'sources',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'ImageSrc',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'NonSkuInterface',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'HistoricalNonSkuGemstone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'HistoricalNonSkuLabGrown',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'NonSkuGemstone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'NonSkuLabGrown',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuLabGrown',
                'fields': [
                    {
                        'name': 'caratDimension',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownCaratDimension',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarity',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCut',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'gradeDimension',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownGradeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Money',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'sampleImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shapeDimension',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownShapeDimension',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'uniqueImage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'NonSkuInterface',
                    },
                    {
                        'kind': 'INTERFACE',
                        'name': 'NonSkuLabGrownInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuLabGrownCaratDimension',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuLabGrownDiamondsBounds',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuCaratWeightRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneColor',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuPriceRange',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'shapes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneShape',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuLabGrownGradeDimension',
                'fields': [
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarity',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'NonSkuLabGrownInterface',
                'fields': [
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarity',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystal',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCut',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'HistoricalNonSkuLabGrown',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'NonSkuLabGrown',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuLabGrownShapeDimension',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'NonSkuPriceRange',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Order',
                'fields': [
                    {
                        'name': 'allowedWeekdays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'availableShowroomsForCollection',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Showroom',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'billingAddress',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderAddress',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Customer',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'desiredDeliveryDate',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'disabledDates',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAsarEnabled',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isCompleted',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isDeliveryConfirmed',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isPayable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isShippingAddressReadonly',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'paidAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'paymentMethods',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'PaymentMethodContainer',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'paymentPlan',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'PaymentPlan',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'placementDate',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'prediscountSubtotalAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'prediscountTotalAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'products',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'OrderProduct',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'promoCode',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PromoCode',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'remainingAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'salesTaxAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'savedAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shipmentTrackingInformation',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'ShipmentTrackingInformation',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'shippingAddress',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderAddress',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shippingAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'status',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'OrderStatus',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'subtotalAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'transactions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'TransactionInterface',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'vatAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'OrderAddress',
                'fields': [
                    {
                        'name': 'addressLine1',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'addressLine2',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'city',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'country',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryInstructions',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'email',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'firstName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'lastName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'phoneNumber',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PhoneNumberType',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'postalCode',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'subdivision',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'OrderAddressNotConfirmedError',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'OrderAlreadyCompletedError',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'OrderEmptyError',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'OrderProduct',
                'fields': [
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Customer',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStudioProduct',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'DesignStudioProduct',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'prediscountTotalSaleAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalSaleAmount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'OrderStatus',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'OrderedListItem',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Page',
                'fields': [
                    {
                        'name': 'author',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Author',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'blocks',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Block',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'meta',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Meta',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'pageSettings',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'PageSettings',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'parent',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Page',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'path',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PageSettings',
                'fields': [
                    {
                        'name': 'showRingBuilder',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PageTooltip',
                'fields': [
                    {
                        'name': 'tooltip',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Tooltip',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'triggerText',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'PayViaCheckoutcomError',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CheckoutcomOperationDeclinedError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesiredDeliveryDateInvalidError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'OrderAlreadyCompletedError',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'PaymentAmountInvalidError',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'PayViaCheckoutcomFailureResponse',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'PayViaCheckoutcomError',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'PayViaCheckoutcomResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'PayViaCheckoutcomFailureResponse',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'PayViaCheckoutcomSuccessResponse',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'PayViaCheckoutcomSuccessResponse',
                'fields': [
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'redirectUrl',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PaymentAmountInvalidError',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PaymentIcon',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PaymentMethodContainer',
                'fields': [
                    {
                        'name': 'affirmPayment',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmPaymentMethod',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'allocationPayment',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AllocationPaymentMethod',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'bankPayment',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'BankPaymentMethod',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'checkoutcomPayment',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CheckoutcomPaymentMethod',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'klarnaPayment',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaPaymentMethod',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'noPayment',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NoPaymentMethod',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PaymentMethodNotAllowedError',
                'fields': [
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PaymentPlan',
                'fields': [
                    {
                        'name': 'current',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PaymentPlanUpcomingRecord',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'paid',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'PaymentPlanPaidRecord',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'upcoming',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'PaymentPlanUpcomingRecord',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PaymentPlanPaidRecord',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'paidOn',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PaymentPlanUpcomingRecord',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PhoneNumberType',
                'fields': [
                    {
                        'name': 'countryCode',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'e164',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'formatted',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'format',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nationalNumber',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Post',
                'fields': [
                    {
                        'name': 'author',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Author',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'blocks',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Block',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'categories',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'PostCategory',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'date',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'excerpt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'featuredImage',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'meta',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Meta',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'modifiedAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'relatedPosts',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'OBJECT',
                                    'name': 'Post',
                                    'ofType': null,
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'showModifiedDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'tags',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'PostTag',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PostCategoriesAggregation',
                'fields': [
                    {
                        'name': 'count',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PostCategory',
                'fields': [
                    {
                        'name': 'children',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'NON_NULL',
                                'ofType': {
                                    'kind': 'OBJECT',
                                    'name': 'PostCategory',
                                    'ofType': null,
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'parent',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PostCategory',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'postAggregation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'PostsAggregation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'posts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Post',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'page',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PostTag',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'postAggregation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'PostsAggregation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'posts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Post',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'page',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PostTagsAggregation',
                'fields': [
                    {
                        'name': 'count',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PostsAggregation',
                'fields': [
                    {
                        'name': 'count',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PreHeader',
                'fields': [
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ProductLabelTranslation',
                'fields': [
                    {
                        'name': 'facetedContentName',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ProductPageDetails',
                'fields': [
                    {
                        'name': 'blocks',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Block',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'meta',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Meta',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'path',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'priceExplainedTooltip',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PageTooltip',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ProductPageFacetedContent',
                'fields': [
                    {
                        'name': 'contentTitle',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'longDescription',
                        'type': {
                            'kind': 'UNION',
                            'name': 'ProductPageFacetedContentLongDescription',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'meta',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Meta',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'productString',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'ProductPageFacetedContentLongDescription',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'ProductPageFacetedContentLongDescriptionBlock',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ProductPageFacetedContentLongDescriptionText',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ProductPageFacetedContentLongDescriptionBlock',
                'fields': [
                    {
                        'name': 'blocks',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Block',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ProductPageFacetedContentLongDescriptionText',
                'fields': [
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ProductPageListing',
                'fields': [
                    {
                        'name': 'afterGrid',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Block',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'banner1',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Banner1',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'banner2',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Banner2',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'beforeFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Block',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'meta',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Meta',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'path',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'slug',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PromoCode',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'PromoCodeApplicationResult',
                'fields': [
                    {
                        'name': 'error',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Query',
                'fields': [
                    {
                        'name': 'GemsApi_findStones',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_StoneCollection',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filters',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'GemsApi_getBounds',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_Bounds',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'categories',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                            {
                                'name': 'isConsultant',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'market',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'notClarity',
                                'type': {
                                    'kind': 'LIST',
                                    'ofType': {
                                        'kind': 'NON_NULL',
                                        'ofType': {
                                            'kind': 'SCALAR',
                                            'name': 'Any',
                                        },
                                    },
                                },
                            },
                            {
                                'name': 'notColour',
                                'type': {
                                    'kind': 'LIST',
                                    'ofType': {
                                        'kind': 'NON_NULL',
                                        'ofType': {
                                            'kind': 'SCALAR',
                                            'name': 'Any',
                                        },
                                    },
                                },
                            },
                            {
                                'name': 'notSymmetry',
                                'type': {
                                    'kind': 'LIST',
                                    'ofType': {
                                        'kind': 'NON_NULL',
                                        'ofType': {
                                            'kind': 'SCALAR',
                                            'name': 'Any',
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'GemsApi_getGiaStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_Stone',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'giaCertificate',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'GemsApi_getStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_Stone',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'identifier',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'GemsApi_getStoneByExternalId',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GemsApi_Stone',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'externalId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'feedIdentifier',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'GemsApi_getStones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'OBJECT',
                                    'name': 'GemsApi_Stone',
                                    'ofType': null,
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'identifiers',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'authorById',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Author',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'authorBySlug',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Author',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'slug',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'authors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Author',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'authorsAggregation',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AuthorsAggregation',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'avatarStack',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'AvatarStackItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'bookingAvailableTransitions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'bookingConsultants',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Consultant',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'bookingConsultation',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'BookingConsultation',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'bookingConsultationAvailableSlots',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'BookingConsultationSlotsResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'bookingConsultationAvailableSlotsByConsultant',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'BookingConsultationAvailableDate',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'consultant',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'consultationMethod',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'consultationPurpose',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'consultationRoom',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'consultationRoomKind',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'ignoreConsultation',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'order',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'showroom',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'bookingConsultationComplexities',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'BookingConsultationComplexity',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'bookingConsultationPurposes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'BookingConsultationPurpose',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'bookingConsultationShowPhone',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'bookingCustomer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Customer',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'bookingInPersonConsultationRooms',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'BookingConsultationRoom',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'consultationPurposeId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'kind',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'showroomId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'bookingShowrooms',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Showroom',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'bookingVirtualConsultationRooms',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'BookingConsultationRoom',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'consultationPurposeId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'kind',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'showroomId',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'calculateGemsApiStoneTotalSalePrices',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Money',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueEngagementRing',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueEngagementRing',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueEngagementRingContainsProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueEngagementRingFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueEngagementRingFilters',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueEngagementRingFiltersVariations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueEngagementRingFiltersVariation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'maxSlots',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueEngagementRings',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueEngagementRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueEngagementRingsAggregate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueAggregate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleries',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'CatalogueJewellery',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleriesAggregate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueAggregate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleriesFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueJewelleriesFilters',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleriesFiltersVariations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleriesFiltersVariation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'maxSlots',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewellery',
                        'type': {
                            'kind': 'INTERFACE',
                            'name': 'CatalogueJewellery',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'type',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryBracelet',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueJewelleryBracelet',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryBraceletFiltersVariations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleriesBraceletsFiltersVariation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'maxSlots',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryBracelets',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryBracelet',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryBraceletsAggregate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueAggregate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryBraceletsFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueJewelleryBraceletsFilters',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryEarring',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueJewelleryEarrings',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryEarrings',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryEarrings',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryEarringsAggregate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueAggregate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryEarringsFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueJewelleryEarringsFilters',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryEarringsFiltersVariations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleriesEarringsFiltersVariation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'maxSlots',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryNecklace',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueJewelleryNecklace',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryNecklaces',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryNecklace',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryNecklacesAggregate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueAggregate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryNecklacesFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueJewelleryNecklacesFilters',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryNecklacesFiltersVariations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleriesNecklacesFiltersVariation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'maxSlots',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryRing',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueJewelleryRing',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryRings',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleryRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryRingsAggregate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueAggregate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryRingsFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueJewelleryRingsFilters',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueJewelleryRingsFiltersVariations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueJewelleriesRingsFiltersVariation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'maxSlots',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueProducts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'CatalogueProduct',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueReadyToGoRing',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueReadyToGoRing',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueReadyToGoRings',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueReadyToGoRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueReadyToGoRingsAggregate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueAggregate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueReadyToGoRingsFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueReadyToGoRingFilters',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueWeddingRing',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueWeddingRing',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueWeddingRingFilterVariations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueWeddingRingFiltersVariation',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'maxSlots',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueWeddingRingFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueWeddingRingFilters',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueWeddingRings',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueWeddingRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'catalogueWeddingRingsAggregate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CatalogueAggregate',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'convertPriceBoundsForGems',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'GemsApiPriceBounds',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'convertPriceBoundsForGemsMulti',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'GemsApiPriceBounds',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'customerExists',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'email',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'defaultAlternateRegion',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Region',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'defaultRegion',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Region',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'deliveryDaysForBespokeEngagementRings',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'engagementRingStoneRecommendations',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'EngagementRingStoneRecommendations',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'footer',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Footer',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'language',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Language',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'languages',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Language',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mainMenu',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'MenuItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'me',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'User',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'metals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Metal',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuGemStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuGemstone',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemStones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuGemstone',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'filters',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemStonesBounds',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuGemstonesBounds',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuGemStonesPricingCells',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuGemstone',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filters',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuGemstoneCaratDimensions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuGemstoneCaratDimension',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuGemstoneColorCrystalDimensions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuGemstoneType',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuGemstoneGradeClarityDimensions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuGemstoneGradeClarityDimension',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuGemstoneImages',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuGemstoneImage',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuGemstoneShapeDimensions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuGemstoneShapeDimension',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuLabGrownCaratDimensions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuLabGrownCaratDimension',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuLabGrownDiamond',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'NonSkuLabGrown',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownDiamonds',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuLabGrown',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'filters',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'sort',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownDiamondsBounds',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'NonSkuLabGrownDiamondsBounds',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuLabGrownGradeDimensions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuLabGrownGradeDimension',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuLabGrownPricingCells',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuLabGrown',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filters',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownShapeDimensions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'NonSkuLabGrownShapeDimension',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'pageByPath',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Page',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'path',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'pageProductDetails',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'ProductPageDetails',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'fallback',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'path',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'pageProductListing',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'ProductPageListing',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'path',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'pageProductListingFacetedContent',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'ProductPageFacetedContent',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'pages',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Page',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'paymentIcons',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'PaymentIcon',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'ping',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'postBySlug',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Post',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'slug',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'postCategories',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'PostCategory',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'postCategoriesAggregation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'PostCategoriesAggregation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'postCategoryBySlug',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PostCategory',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'slug',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'postTagAggregation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'PostTagsAggregation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'postTagBySlug',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PostTag',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'slug',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'postTags',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'PostTag',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'posts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Post',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'pagination',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'postsAggregation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'PostsAggregation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'preHeader',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'PreHeader',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'questionnaire',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Questionnaire',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'id',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'questionnaires',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Questionnaire',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'region',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Region',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'code',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'regionSuggest',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Region',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'regions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Region',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'reviews',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Review',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'ringBuilder',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'RingBuilder',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'searchEverywhere',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SearchEverywhereResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'justMe',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'query',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'socialNetworks',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'SocialNetwork',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneCategoriesBySystemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneCategory',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneCategoryBySystemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCategory',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCode',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneClarities',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneClarity',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneClaritiesBySystemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneClarity',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneClarityBySystemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarity',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCode',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneColorBySystemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCode',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneColors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneColor',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneColorsBySystemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneColor',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneCrystals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneCrystal',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneCrystalsBySystemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneCrystal',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneCutsBySystemCodes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneCut',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneFluorescencesBySystemCodes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneFluorescence',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneGrades',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneGrade',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneGradesBySystemCodes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneGrade',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stonePolishesBySystemCodes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StonePolish',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneShapeBySystemCodes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneShape',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneShapes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneShape',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'filter',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneSymmetriesBySystemCodes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneSymmetry',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'systemCodes',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'LIST',
                                        'ofType': {
                                            'kind': 'NON_NULL',
                                            'ofType': {
                                                'kind': 'SCALAR',
                                                'name': 'Any',
                                            },
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'tooltip',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Tooltip',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'path',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'topBar',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'TopBar',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'validateConsultationInput',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'validateCustomerRegistrationInput',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'input',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'workingHours',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'WorkingHours',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Questionnaire',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'redirectLink',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'LinkItem',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'signUpStep',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireSignUpStep',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'steps',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireStep',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'type',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'QuestionnaireAnswer',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireQuestionSnapshot',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionAnswerMultiChoice',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionAnswerNumber',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionAnswerSingleChoice',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionAnswerText',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireCompletedExistingCustomerResponse',
                'fields': [
                    {
                        'name': 'questionnaire',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireCompletedQuestionnaire',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireCompletedNewCustomerResponse',
                'fields': [
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CustomerRegistrationResponse',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'questionnaire',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireCompletedQuestionnaire',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireCompletedQuestionnaire',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'referenceId',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'steps',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireCompletedQuestionnaireStepSnapshot',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'type',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireCompletedQuestionnaireStepSnapshot',
                'fields': [
                    {
                        'name': 'answers',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'QuestionnaireAnswer',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireCondition',
                'fields': [
                    {
                        'name': 'rules',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'QuestionnaireConditionRule',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'type',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireConditionEqualToChoice',
                'fields': [
                    {
                        'name': 'choice',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'QuestionnaireQuestionChoiceOption',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'INTERFACE',
                                'name': 'QuestionnaireQuestion',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireConditionIsEmpty',
                'fields': [
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'INTERFACE',
                                'name': 'QuestionnaireQuestion',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireConditionIsEqualTo',
                'fields': [
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'INTERFACE',
                                'name': 'QuestionnaireQuestion',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'value',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireConditionIsGreaterThan',
                'fields': [
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'INTERFACE',
                                'name': 'QuestionnaireQuestion',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'value',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireConditionIsLessThan',
                'fields': [
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'INTERFACE',
                                'name': 'QuestionnaireQuestion',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'value',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireConditionIsNotEmpty',
                'fields': [
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'INTERFACE',
                                'name': 'QuestionnaireQuestion',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireConditionNotIsEqualTo',
                'fields': [
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'INTERFACE',
                                'name': 'QuestionnaireQuestion',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'value',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'QuestionnaireConditionRule',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireConditionEqualToChoice',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireConditionIsEmpty',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireConditionIsEqualTo',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireConditionIsGreaterThan',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireConditionIsLessThan',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireConditionIsNotEmpty',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireConditionNotIsEqualTo',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireCustomerNotification',
                'fields': [
                    {
                        'name': 'subject',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'QuestionnaireQuestion',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'required',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoice',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionPrice',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionText',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionAnswerMultiChoice',
                'fields': [
                    {
                        'name': 'choices',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireQuestionChoiceOptionSnapshot',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireQuestionSnapshot',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireAnswer',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionAnswerNumber',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'number',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireQuestionSnapshot',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireAnswer',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionAnswerSingleChoice',
                'fields': [
                    {
                        'name': 'choice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireQuestionChoiceOptionSnapshot',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireQuestionSnapshot',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireAnswer',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionAnswerText',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'question',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'QuestionnaireQuestionSnapshot',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireAnswer',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoice',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'multiple',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'options',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireQuestionChoiceOption',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'required',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestion',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOption',
                'fields': [
                    {
                        'name': 'behaviour',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'QuestionnaireQuestionChoiceOptionBehaviour',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'QuestionnaireQuestionChoiceOptionContent',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionBehaviour',
                'fields': [
                    {
                        'name': 'designFeature',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'metal',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringStyle',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'QuestionnaireQuestionChoiceOptionContent',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentIconCard',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImage',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImageCard',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentText',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionContentIconCard',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'conditionalContent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireQuestionChoiceOptionContentIconCardConditional',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestionChoiceOptionContentIconCardInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionContentIconCardConditional',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'conditions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireCondition',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestionChoiceOptionContentIconCardInterface',
                    },
                ],
            },
            {
                'kind': 'INTERFACE',
                'name': 'QuestionnaireQuestionChoiceOptionContentIconCardInterface',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentIconCard',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentIconCardConditional',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionContentImage',
                'fields': [
                    {
                        'name': 'conditionalContent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireQuestionChoiceOptionContentImageConditional',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImageInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionContentImageCard',
                'fields': [
                    {
                        'name': 'conditionalContent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireQuestionChoiceOptionContentImageCardConditional',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImageCardInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionContentImageCardConditional',
                'fields': [
                    {
                        'name': 'conditions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireCondition',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImageCardInterface',
                    },
                ],
            },
            {
                'kind': 'INTERFACE',
                'name': 'QuestionnaireQuestionChoiceOptionContentImageCardInterface',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImageCard',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImageCardConditional',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionContentImageConditional',
                'fields': [
                    {
                        'name': 'conditions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireCondition',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImageInterface',
                    },
                ],
            },
            {
                'kind': 'INTERFACE',
                'name': 'QuestionnaireQuestionChoiceOptionContentImageInterface',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImage',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentImageConditional',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionContentText',
                'fields': [
                    {
                        'name': 'conditionalContent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireQuestionChoiceOptionContentTextConditional',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestionChoiceOptionContentTextInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionContentTextConditional',
                'fields': [
                    {
                        'name': 'conditions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireCondition',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestionChoiceOptionContentTextInterface',
                    },
                ],
            },
            {
                'kind': 'INTERFACE',
                'name': 'QuestionnaireQuestionChoiceOptionContentTextInterface',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentText',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionContentTextConditional',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshot',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshotImage',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshotText',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshotImage',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshotText',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionChoiceOptionSnapshot',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'layout',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'QuestionnaireQuestionChoiceOptionLayoutSnapshot',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'referenceId',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionPrice',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'required',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'tooltip',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestion',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionSnapshot',
                'fields': [
                    {
                        'name': 'referenceId',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireQuestionText',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'required',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'textarea',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'QuestionnaireQuestion',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireSignUpStep',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireStep',
                'fields': [
                    {
                        'name': 'conditions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireCondition',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'QuestionnaireStepContent',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'excludeFromProgressIndicator',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'help',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Block',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'QuestionnaireStepContent',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireStepContentContent',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuestionnaireStepContentQuestions',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireStepContentContent',
                'fields': [
                    {
                        'name': 'blocks',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Block',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'conditions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireCondition',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireStepContentQuestions',
                'fields': [
                    {
                        'name': 'conditions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuestionnaireCondition',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'questions',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'QuestionnaireQuestion',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuestionnaireSubmissionNotification',
                'fields': [
                    {
                        'name': 'emails',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'Quotation',
                'fields': [
                    {
                        'name': 'baseTemplate',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'customName',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalUntil',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isRecommended',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isSalesTaxApplicable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isVatApplicable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalSalePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'QuotationEngagementRing',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'QuotationWeddingRing',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuotationEngagementRing',
                'fields': [
                    {
                        'name': 'baseTemplate',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'centreStone',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DesignStudioEngagementRingCentreStone',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customName',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalUntil',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isRecommended',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isSalesTaxApplicable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isVatApplicable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DesignStudioEngagementRingMount',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalSalePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'Quotation',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuotationManualSurcharge',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuotationPercentageSurcharge',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'percent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'QuotationWeddingRing',
                'fields': [
                    {
                        'name': 'baseTemplate',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'comment',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'customName',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'finalUntil',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'firstAvailableDeliveryDate',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'DeliveryDate',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'images',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isRecommended',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isSalesTaxApplicable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isVatApplicable',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'manualSurcharges',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'QuotationManualSurcharge',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'metals',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Metal',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'percentageSurcharge',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'QuotationPercentageSurcharge',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'DesignStudioSignatureStone',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalSalePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'Quotation',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'RecommendedRingSize',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'ringSize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'RingSize',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Region',
                'fields': [
                    {
                        'name': 'code',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'currency',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isActive',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'language',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Language',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'locales',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'representingCountry',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Review',
                'fields': [
                    {
                        'name': 'comment',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'date',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'picture',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'products',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'INTERFACE',
                                        'name': 'CatalogueProduct',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'types',
                                'type': {
                                    'kind': 'LIST',
                                    'ofType': {
                                        'kind': 'NON_NULL',
                                        'ofType': {
                                            'kind': 'SCALAR',
                                            'name': 'Any',
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'rating',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ReviewCarouselCard',
                'fields': [
                    {
                        'name': 'author',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'date',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'review',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'starsCount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'RingBuilder',
                'fields': [
                    {
                        'name': 'failure',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'DesignStudioEngagementRingFailure',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'financeOptionsAffirm',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'AffirmFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'financeOptionsKlarna',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'KlarnaFinanceOption',
                            'ofType': null,
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GenericImage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'position1',
                        'type': {
                            'kind': 'UNION',
                            'name': 'RingBuilderFragment',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'position2',
                        'type': {
                            'kind': 'UNION',
                            'name': 'RingBuilderFragment',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'productId',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'salePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'SalePrice',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'stoneRecommendations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'StoneRecommendationsResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'maxPrice',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'minPrice',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'totalSalePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'RingBuilderCentreStone',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'GemsApiStone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'NonSkuGemstone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'NonSkuLabGrown',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'RingBuilderCentreStoneFragment',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'stone',
                        'type': {
                            'kind': 'UNION',
                            'name': 'RingBuilderCentreStone',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'totalSalePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'RingBuilderFragment',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'RingBuilderCentreStoneFragment',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'RingBuilderMountFragment',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'RingBuilderMountFragment',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ring',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueEngagementRing',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'signatureStone',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'CatalogueEngagementRingSignatureStone',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'stoneRecommendations',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'StoneRecommendationsResponse',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'maxPrice',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'minPrice',
                                'type': {
                                    'kind': 'SCALAR',
                                    'name': 'Any',
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'totalSalePrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'RingBuilderResolveResult',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'DesignStudioEngagementRingFailure',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'RingBuilderResolvedExistingCustomer',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'RingBuilderResolvedExistingCustomerSuccess',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'RingBuilderResolvedFailure',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'RingBuilderResolvedExistingCustomerSuccess',
                'fields': [
                    {
                        'name': 'data',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'RingBuilderResolveResult',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'redirect',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringBuilder',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'RingBuilder',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'RingBuilderResolvedFailure',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringBuilder',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'RingBuilder',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'RingBuilderResolvedNewCustomer',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'RingBuilderResolvedFailure',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'RingBuilderResolvedNewCustomerSuccess',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'RingBuilderResolvedNewCustomerSuccess',
                'fields': [
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'CustomerRegistrationResponse',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'data',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'RingBuilderResolveResult',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'redirect',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringBuilder',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'RingBuilder',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'RingBuilderSetResult',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringBuilder',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'RingBuilder',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'RingSize',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'label',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [
                            {
                                'name': 'region',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'RingSizeOrRecommendedRingSize',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'RecommendedRingSize',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'RingSize',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'SalePrice',
                'fields': [
                    {
                        'name': 'tax',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Tax',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'total',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'SearchEverywhereResponse',
                'fields': [
                    {
                        'name': 'customers',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Customer',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'orders',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'Order',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'products',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'DesignStudioProductGeneric',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'SetDeliveryInformationError',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'OrderAlreadyCompletedError',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'SetDeliveryInformationFailureResponse',
                'fields': [
                    {
                        'name': 'errors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'SetDeliveryInformationError',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'SetDeliveryInformationResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'SetDeliveryInformationFailureResponse',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'SetDeliveryInformationSuccessResponse',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'SetDeliveryInformationSuccessResponse',
                'fields': [
                    {
                        'name': 'order',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Order',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShipmentTrackingInformation',
                'fields': [
                    {
                        'name': 'dispatchedAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shippingCompany',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'trackingNumber',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'trackingUrl',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'ShopWithConfidenceComponent',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'ShopWithConfidenceEthnicallySourcedDiamonds',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ShopWithConfidenceFinancingOptions',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ShopWithConfidenceGreenlandRuby',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ShopWithConfidenceHandFinished',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ShopWithConfidenceResize',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ShopWithConfidenceReturnPolicy',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'ShopWithConfidenceShipping',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShopWithConfidenceEthnicallySourcedDiamonds',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'ShopWithConfidenceComponent',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShopWithConfidenceFinancingOptions',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'ShopWithConfidenceComponent',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShopWithConfidenceGreenlandRuby',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'ShopWithConfidenceComponent',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShopWithConfidenceHandFinished',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'ShopWithConfidenceComponent',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShopWithConfidenceResize',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'ShopWithConfidenceComponent',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShopWithConfidenceReturnPolicy',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'ShopWithConfidenceComponent',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShopWithConfidenceShipping',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'ShopWithConfidenceComponent',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'Showroom',
                'fields': [
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isAccessible',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'location',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ShowroomLocation',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'timezone',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ShowroomTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShowroomLocation',
                'fields': [
                    {
                        'name': 'addressLine1',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'addressLine2',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'city',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'country',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'geoLocation',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'GeoPoint',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'postalCode',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'subdivision',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'ShowroomTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'SocialNetwork',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'SquareBoxes',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'SquareImageBox',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'SquareTextBox',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'SquareImageBox',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Link',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'SquareTextBox',
                'fields': [
                    {
                        'name': 'backgroundColor',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Stone',
                'fields': [
                    {
                        'name': 'caratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'certificate',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneCertificate',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'clarity',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneClarity',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneColor',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'colorGrade',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneGrade',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'crystal',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneCrystal',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'cut',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneCut',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'depthPercent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'fluorescence',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneFluorescence',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'measurements',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneMeasurements',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'photo',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'polish',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StonePolish',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'ratio',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneShape',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'symmetry',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneSymmetry',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'tablePercent',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneCategory',
                'fields': [
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCategoryTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneCategoryTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneCertificate',
                'fields': [
                    {
                        'name': 'number',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'uri',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneClarity',
                'fields': [
                    {
                        'name': 'abbreviation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneClarityTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneClarityTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneColor',
                'fields': [
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColorTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneColorTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneCrystal',
                'fields': [
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCrystalTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneCrystalTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneCut',
                'fields': [
                    {
                        'name': 'abbreviation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCutTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneCutTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneFluorescence',
                'fields': [
                    {
                        'name': 'abbreviation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneFluorescenceTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneFluorescenceTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneGrade',
                'fields': [
                    {
                        'name': 'category',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneCategory',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneGradeTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneGradeTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneMeasurements',
                'fields': [
                    {
                        'name': 'depth',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'length',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StonePolish',
                'fields': [
                    {
                        'name': 'abbreviation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StonePolishTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StonePolishTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'StoneRecommendationGemsApiStone',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'GemsApi_Stone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'StoneRecommendationNotFound',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneRecommendationNonSkuGemstone',
                'fields': [
                    {
                        'name': 'color',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneColor',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'item',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'StoneRecommendationNonSkuGemstoneItem',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'StoneRecommendationNonSkuGemstoneItem',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'NonSkuGemstone',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'StoneRecommendationNotFound',
                    },
                ],
            },
            {
                'kind': 'UNION',
                'name': 'StoneRecommendationNonSkuLabGrownItem',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'NonSkuLabGrown',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'StoneRecommendationNotFound',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneRecommendationNotFound',
                'fields': [
                    {
                        'name': 'haveWithoutPricingRange',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneRecommendationsNaturalDiamondFilters',
                'fields': [
                    {
                        'name': 'clarities',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneClarity',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'colors',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneColor',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'cuts',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneCut',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'depthPercentRange',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneRecommendationsPercentRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'fluorescences',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneFluorescence',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'maxCaratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'minCaratWeight',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'polishes',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StonePolish',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'priceMax',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'priceMin',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'currency',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'region',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Region',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShape',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'symmetries',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneSymmetry',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'tablePercentRange',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneRecommendationsPercentRange',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneRecommendationsPercentRange',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneRecommendationsPriceRange',
                'fields': [
                    {
                        'name': 'max',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'min',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'UNION',
                'name': 'StoneRecommendationsResponse',
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'StoneRecommendationsResponseFailure',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'StoneRecommendationsResponseSuccess',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneRecommendationsResponseFailure',
                'fields': [
                    {
                        'name': 'error',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneRecommendationsResponseSuccess',
                'fields': [
                    {
                        'name': 'naturalDiamondBestForBalance',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'StoneRecommendationGemsApiStone',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'naturalDiamondBestForBalanceFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneRecommendationsNaturalDiamondFilters',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'naturalDiamondBestForSize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'StoneRecommendationGemsApiStone',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'naturalDiamondBestForSizeFilters',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneRecommendationsNaturalDiamondFilters',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuGemStones',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'StoneRecommendationNonSkuGemstone',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'colorCodes',
                                'type': {
                                    'kind': 'LIST',
                                    'ofType': {
                                        'kind': 'NON_NULL',
                                        'ofType': {
                                            'kind': 'SCALAR',
                                            'name': 'Any',
                                        },
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'nonSkuLabGrownBestForPrice',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'StoneRecommendationNonSkuLabGrownItem',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'nonSkuLabGrownBestForSize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'UNION',
                                'name': 'StoneRecommendationNonSkuLabGrownItem',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'priceBounds',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneRecommendationsPriceRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'priceInitialValues',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneRecommendationsPriceRange',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneShape',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'samplePhoto',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneShapeTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneShapeTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneSymmetry',
                'fields': [
                    {
                        'name': 'abbreviation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'StoneSymmetryTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StoneSymmetryTranslation',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'StripeTransaction',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'status',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'TransactionStatus',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'TransactionInterface',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'SubMenu',
                'fields': [
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'editorialContent',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'SubMenuEditorialContent',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'sections',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'SubMenuSection',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'useLargeFormatItems',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'SubMenuEditorialContent',
                'fields': [
                    {
                        'name': 'image',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Image',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'SubMenuItem',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'media',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Image',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'style',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'SubMenuSection',
                'fields': [
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'SubMenuItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Table',
                'fields': [
                    {
                        'name': 'body',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'TableBody',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'header',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'TableHeader',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'TableBody',
                'fields': [
                    {
                        'name': 'rows',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'TableRow',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'TableHeader',
                'fields': [
                    {
                        'name': 'cells',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'TableRow',
                'fields': [
                    {
                        'name': 'cells',
                        'type': {
                            'kind': 'LIST',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Tax',
                'fields': [
                    {
                        'name': 'price',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'type',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'TextCarouselItem',
                'fields': [
                    {
                        'name': 'text',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Tooltip',
                'fields': [
                    {
                        'name': 'content',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'UNION',
                                        'name': 'ContentComponentItem',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'TopBar',
                'fields': [
                    {
                        'name': 'consultationPrompt',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'TopBarConsultationPrompt',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'siteWideMessage',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'TopBarSiteWideMessage',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'TopBarConsultationPrompt',
                'fields': [
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'TopBarSiteWideMessage',
                'fields': [
                    {
                        'name': 'link',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Link',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'message',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'INTERFACE',
                'name': 'TransactionInterface',
                'fields': [
                    {
                        'name': 'amount',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'Money',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'status',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'TransactionStatus',
                                'ofType': null,
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
                'possibleTypes': [
                    {
                        'kind': 'OBJECT',
                        'name': 'AffirmTransaction',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'AllocationTransaction',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'BankTransaction',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'CheckoutcomTransaction',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'KlarnaTransaction',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'LegacyTransaction',
                    },
                    {
                        'kind': 'OBJECT',
                        'name': 'StripeTransaction',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'TransactionStatus',
                'fields': [
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Translation',
                'fields': [
                    {
                        'name': 'token',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'User',
                'fields': [
                    {
                        'name': 'createdAt',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'customer',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Customer',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'email',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'firstName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'isConsultant',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'lastName',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'UserCustomerEngagementRingRecommendations',
                'fields': [
                    {
                        'name': 'designFeature',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'EngagementRingDesignFeatureLabel',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'designStyle',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'EngagementRingDesignStyleLabel',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'items',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'OBJECT',
                                        'name': 'CatalogueEngagementRing',
                                        'ofType': null,
                                    },
                                },
                            },
                        },
                        'args': [
                            {
                                'name': 'limit',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                            {
                                'name': 'page',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                    {
                        'name': 'metal',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Metal',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'ringStyle',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'EngagementRingStyleLabel',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'shape',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'StoneShape',
                            'ofType': null,
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'Video',
                'fields': [
                    {
                        'name': 'alt',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'caption',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'description',
                        'type': {
                            'kind': 'SCALAR',
                            'name': 'Any',
                        },
                        'args': [],
                    },
                    {
                        'name': 'filename',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'filesize',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'height',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'id',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'mimeType',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'name',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'title',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'url',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'width',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [
                    {
                        'kind': 'INTERFACE',
                        'name': 'Media',
                    },
                ],
            },
            {
                'kind': 'OBJECT',
                'name': 'WeddingRingCategoryLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'WeddingRingStyleLabel',
                'fields': [
                    {
                        'name': 'icon',
                        'type': {
                            'kind': 'OBJECT',
                            'name': 'Asset',
                            'ofType': null,
                        },
                        'args': [],
                    },
                    {
                        'name': 'systemCode',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'translation',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'OBJECT',
                                'name': 'ProductLabelTranslation',
                                'ofType': null,
                            },
                        },
                        'args': [
                            {
                                'name': 'locale',
                                'type': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        ],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'OBJECT',
                'name': 'WorkingHours',
                'fields': [
                    {
                        'name': 'closing',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'opening',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'SCALAR',
                                'name': 'Any',
                            },
                        },
                        'args': [],
                    },
                    {
                        'name': 'weekDays',
                        'type': {
                            'kind': 'NON_NULL',
                            'ofType': {
                                'kind': 'LIST',
                                'ofType': {
                                    'kind': 'NON_NULL',
                                    'ofType': {
                                        'kind': 'SCALAR',
                                        'name': 'Any',
                                    },
                                },
                            },
                        },
                        'args': [],
                    },
                ],
                'interfaces': [],
            },
            {
                'kind': 'SCALAR',
                'name': 'Any',
            },
        ],
        'directives': [],
    },
} as unknown as IntrospectionQuery
